import { writable } from "svelte/store";

export const currentPage = writable<string>("configuration");
